// 🧿 طلسم محافظ فایل
// Common Components
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Requests
import { getIVPutTable } from "src/Requests/automaticMarketMaking";
// Types
import {
  IIVPutSearchParams,
  IIVTablePutReport,
} from "src/Interfaces/automaticMarketMaking";

interface IProps {
  searchParam: IIVPutSearchParams;
  onRowClick: (id: string) => void;
  setTitle: (name: string) => void;
}

const IVPutTable = ({ searchParam, onRowClick, setTitle }: IProps) => {
  const onTableRowClick = (row: IIVTablePutReport) => {
    onRowClick(row.putOptionCode);
    setTitle(row.putOptionName);
  };

  return (
    <TableTemplate
      TableUI={({ reports, sortingType, setSortingType, getExtraTypeUI }) => (
        <CommonTableUI
          reports={reports}
          tableBoxClassName="max-h-[500px]"
          sortingType={sortingType}
          setSortingType={setSortingType}
          getExtraTypeUI={getExtraTypeUI}
          onTableRowClick={onTableRowClick}
          withSelect
        />
      )}
      getDataTable={getIVPutTable}
      withSort
      searchParameters={searchParam}
      refreshTableTime={30000}
    />
  );
};

export default IVPutTable;
